import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'

const geolocationClientsSlice = createSlice({
  name: 'geolocationClients',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const geolocationClientsActions = geolocationClientsSlice.actions
export const { reducer: geolocationClientsReducer } = geolocationClientsSlice
